var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-filter',{staticClass:"mb-10",attrs:{"title":_vm.$t('form.choose_class'),"filters":_vm.filters,"loading":_vm.loadingClasses,"collapseAction":true},on:{"reFilter":_vm.reFilter}}),_c('gradeBookTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }